import Head from "next/head";
import styles from './styles.module.css';
import Header from "@/shared/components/Header";
import Footer from "@/shared/components/Footer";

const Clima = (props) => {
    const rawWeather = props.content;
    const menues = props.menu || [];
    const iconUrl = "/img/clima/";

    const hoursFormatter = (unixHour) => {
        const date = new Date(unixHour * 1000);
        const hour = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        return `${hour}:${minutes}`;
    };

    const formatWeatherData = (data) => {
        if (!data || data.error) {
            return null;
        }

        const processedData = JSON.parse(JSON.stringify(data));

        if (processedData.forecast && processedData.forecast.days) {
            processedData.forecast.days.splice(0, 1);
        }

        return {
            ...processedData,
            updatedAt: hoursFormatter(processedData.updatedAt),
            sun: {
                ...processedData.sun,
                rise: hoursFormatter(processedData.sun.rise),
                set: hoursFormatter(processedData.sun.set),
            },
            moon: {
                ...processedData.moon,
                rise: hoursFormatter(processedData.moon.rise),
                set: hoursFormatter(processedData.moon.set),
            },
            forecast: {
                ...processedData.forecast,
                hours: processedData.forecast.hours.map((h) => ({
                    ...h,
                    hour: hoursFormatter(h.hour),
                })),
            },
        };
    };

    const weather = formatWeatherData(rawWeather);

    if (!weather) {
        return (
            <>
                <Header menues={menues} />
                <div className={styles['parent-error']}>
                    <h1>Error</h1>
                    <p>{rawWeather?.error || "No se pudieron obtener los datos del clima."}</p>
                </div>
                <Footer />
            </>
        )
    }

    return (
        <>
            <Head>
                <title>{`Clima Extendido en ${weather.name}`}</title>
                <meta name="description" property="description" content={`Prónóstico extendido, salida sol y luna. Clima próximos días en ${weather.name}.  | El Litoral de Santa Fe. Noticias actualizadas las 24 horas.`}/>
                <link rel="image_src" href="https://www.ellitoral.com/collections/img-redes-vista-previa/compartir-clima___689c8c6323845b001a56ac6d.jpg" />
                <meta property="og:image" content="https://www.ellitoral.com/collections/img-redes-vista-previa/compartir-clima___689c8c6323845b001a56ac6d.jpg" />
            </Head>
            <Header menues={menues} />
            <div className={styles['cls-parent']}>
                <div className={styles["clima-parent"]}>

                    <h1>{`Clima Extendido en ${weather.name}`}</h1>
                    <h2 className={styles["clima_descri"]}>Consultá el pronóstico del tiempo y el clima hoy en {weather.name}. Conocé como estará el clima, las temperaturas máximas y mínimas. Salida y puesta del Sol y de la Luna en tu ciudad.</h2>

                    {weather.alert && (
                        <div className={styles.alertBanner}>
                            <span className={styles.alertIcon}>⚠️</span>
                            <p><strong>Alerta Meteorológica:</strong> {weather.alert}</p>
                        </div>
                    )}

                    {/* CONTENEDOR FLEX PARA SEPARAR LOS DOS BLOQUES */}
                    <div className={styles.weatherFlexGroup}>

                        {/* --- BLOQUE 1: TARJETA PRINCIPAL DEL CLIMA --- */}
                        <div className={styles.mainWeatherCard}>
                            <div className={styles["clima-img"]}>
                                <p>
                                    {weather.name}: <strong> {weather.conditions}</strong>
                                </p>
                                <img src={`${iconUrl}${weather.icon.padStart(2, "0")}.png`} alt={weather.conditions} />
                            </div>
                            <div className={styles["clima-temp"]}>
                                <div className={styles["clima-data"]}>
                                    <h4>{weather.temp && `${weather.temp}ºC`}<br></br></h4>

                                    <div className={styles["clima-text"]}>
                                        <p>
                                            ST: <strong>{weather.feels}ºC</strong> | Hum:{" "}
                                            <strong>{weather.humidity}%</strong>
                                        </p>
                                        <p>
                                            Presión Alm.: <strong>{weather.pressure} hPa</strong>
                                        </p>
                                        <p>
                                            Vientos: <strong>{weather.wind} km/h</strong>
                                        </p>
                                        <p>
                                            Visibilidad: <strong>{weather.visibility} km</strong>
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>

                        {/* --- BLOQUE 2: TARJETA DE SOL Y LUNA --- */}
                        <div className={styles.sunMoonCard}>

                            {/* Sección Sol */}
                            <div>
                                <div className={styles.astroHeader}>
                                    <div className={styles.astroTitleGroup}>
                                        <span className={styles.iconBoxSun}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="#d97706">
                                                <path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-13c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1s-1-.45-1-1V3c0-.55.45-1 1-1zm0 18c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1s-1-.45-1-1v-2c0-.55.45-1 1-1zM4.22 5.64c.39-.39 1.02-.39 1.41 0l1.41 1.41c.39.39.39 1.02 0 1.41s-1.02.39-1.41 0L4.22 7.05c-.39-.39-.39-1.02 0-1.41zm12.73 12.73c.39-.39 1.02-.39 1.41 0l1.41 1.41c.39.39.39 1.02 0 1.41s-1.02.39-1.41 0l-1.41-1.41c-.39-.38-.39-1.02 0-1.41zM2 12c0-.55.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1H3c-.55 0-1-.45-1-1zm18 0c0-.55.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1h-2c-.55 0-1-.45-1-1zM5.64 19.78c-.39-.39-.39-1.02 0-1.41l1.41-1.41c.39-.39 1.02-.39 1.41 0s.39 1.02 0 1.41l-1.41 1.41c-.39.39-1.02.39-1.41 0zM18.36 5.64c.39.39.39 1.02 0 1.41l-1.41 1.41c-.39.39-1.02.39-1.41 0s-.39-1.02 0-1.41l1.41-1.41c.39-.39 1.02-.39 1.41 0z"/>
                                            </svg>
                                        </span>
                                        <strong>SOL</strong>
                                    </div>
                                </div>

                                <div className={styles.arcContainer}>
                                    <svg className={styles.arcSvg} viewBox="0 0 200 48">
                                        <path d="M 20 42 A 80 32 0 0 1 180 42" fill="none" stroke="#e2e8f0" strokeWidth="2" strokeDasharray="4 4" />
                                        <path d="M 20 42 A 80 32 0 0 1 130 16" fill="none" stroke="#f59e0b" strokeWidth="2.5" />
                                        <circle cx="130" cy="16" r="5.5" fill="#f59e0b" stroke="#fef3c7" strokeWidth="2" />
                                    </svg>
                                    <div className={styles.arcDivider}></div>
                                </div>

                                <div className={styles.timeRow}>
                                    <div className={styles.timeColLeft}>
                                        <span className={styles.timeLabel}>Salida</span>
                                        <strong className={styles.timeValue}>{weather.sun.rise} <span className={styles.timeUnit}>hs</span></strong>
                                    </div>
                                    <div className={styles.timeColRight}>
                                        <span className={styles.timeLabel}>Puesta</span>
                                        <strong className={styles.timeValue}>{weather.sun.set} <span className={styles.timeUnit}>hs</span></strong>
                                    </div>
                                </div>

                                <div className={styles.durationText}>
                                    Duración: <strong>{weather.sun.duration} hs</strong>
                                </div>
                            </div>

                            <hr className={styles.divider} />

                            {/* Sección Luna */}
                            <div>
                                <div className={styles.astroHeader}>
                                    <div className={styles.astroTitleGroup}>
                                        <span className={styles.iconBoxMoon}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="#4338ca">
                                                <path d="M12.3 2c.43 0 .77.35.75.78-.29 5.08 3.65 9.15 8.76 9.15.43 0 .78.35.76.78-.81 5.38-5.46 9.49-10.97 9.49-6.18 0-11.2-5.02-11.2-11.2 0-5.51 4.11-10.16 9.49-10.97.14-.02.29-.03.41-.03z"/>
                                            </svg>
                                        </span>
                                        <strong>LUNA</strong>
                                    </div>
                                    {weather.moon.phase && (
                                        <span className={styles.badgeMoon}>
                                            {weather.moon.phase}
                                        </span>
                                    )}
                                </div>

                                <div className={styles.moonGrid}>
                                    <div className={styles.moonBox}>
                                        <span className={styles.timeLabel}>Salida</span>
                                        <strong className={styles.timeValue}>{weather.moon.rise} <span className={styles.timeUnit}>hs</span></strong>
                                    </div>
                                    <div className={styles.moonBox}>
                                        <span className={styles.timeLabel}>Puesta</span>
                                        <strong className={styles.timeValue}>{weather.moon.set} <span className={styles.timeUnit}>hs</span></strong>
                                    </div>
                                </div>

                                <div className={styles.durationText}>
                                    Duración: <strong>{weather.moon.duration} hs</strong>
                                </div>
                            </div>

                        </div>

                    </div>

                    <h2 className={styles["subtitle"]}>HORA POR HORA</h2>
                    <div className={`${styles["clima-container"]} ${styles["hourlyContainer"]}`}>
                        {weather.forecast.hours &&
                            weather.forecast.hours.map((h) => (
                                <div key={h.hour} className={`${styles["forecast"]} ${styles["hourCard"]}`}>
                                    <h4 className={styles["hour"]}>{h.hour}hs</h4>
                                    <div className={styles["temp"]}>
                                        <h4>{h.temp}º C</h4>
                                        <p> &nbsp;ST: <strong>{h.feel}º C</strong></p>
                                    </div>
                                    <div className={styles["wind"]}>
                                        <h4>Vientos</h4>
                                        <p>{h.wind} km/h</p>
                                    </div>
                                    <div className={styles["hours-conditions"]}>
                                        <p>{h.conditions}</p>
                                    </div>
                                </div>
                            ))}
                    </div>

                    <h2 className={styles.subtitle}>EXTENDIDO</h2>
                    <div className={`${styles["clima-container"]} ${styles["extendedContainer"]}`}>
                        {weather.forecast.days && weather.forecast.days.map((d) => (
                            <div key={d.day} className={styles["forecast"]}>
                                <h4 className={styles["day"]}>{d.day}</h4>
                                <div className={styles["minmax"]}>
                                    <p>Min {d.min}º C</p>
                                    <p>Max {d.max}º C</p>
                                </div>
                                <ul className={styles["conditions"]}>
                                    <li>
                                        <h4>Mañana:</h4>
                                        <p>{d.morning.conditions}</p>
                                    </li>
                                    <li>
                                        <h4>Noche:</h4>
                                        <p>{d.night.conditions}</p>
                                    </li>
                                </ul>
                            </div>
                        ))}
                    </div>

                    <h2 className={`${styles["subtitle"]} ${styles["otrasCiudades"]}`}>OTRAS CIUDADES</h2>
                    <div className={styles["clima-container"]}>
                        <a href="/servicios/clima/" title="Ver clima actualizado de Santa Fe" aria-label="Acceder al clima de Santa Fe, información actualizada" style={{ textDecoration: "none" }}><div className={styles["clima-botones-ciudades"]}>SANTA FE</div></a>
                        <a href="/servicios/clima/rafaela" title="Ver clima actualizado de Rafaela" aria-label="Acceder al clima de Rafaela, información actualizada" style={{ textDecoration: "none" }}><div className={styles["clima-botones-ciudades"]}>RAFAELA</div></a>
                        <a href="/servicios/clima/sunchales" title="Ver clima actualizado de Sunchales" aria-label="Acceder al clima de Sunchales, información actualizada" style={{ textDecoration: "none" }}><div className={styles["clima-botones-ciudades"]}>SUNCHALES</div></a>
                        <a href="/servicios/clima/venado-tuerto" title="Ver clima actualizado de Venado Tuerto" aria-label="Acceder al clima de Venado Tuerto, información actualizada" style={{ textDecoration: "none" }}><div className={styles["clima-botones-ciudades"]}>VENADO TUERTO</div></a>
                        <a href="/servicios/clima/rosario" title="Ver clima actualizado de Rosario" aria-label="Acceder al clima de Rosario, información actualizada" style={{ textDecoration: "none" }}><div className={styles["clima-botones-ciudades"]}>ROSARIO</div></a>
                        <a href="/servicios/clima/reconquista" title="Ver clima actualizado de Reconquista" aria-label="Acceder al clima de Reconquista, información actualizada" style={{ textDecoration: "none" }}><div className={styles["clima-botones-ciudades"]}>RECONQUISTA</div></a>
                        <a href="/servicios/clima/corrientes" title="Ver clima actualizado de Corrientes" aria-label="Acceder al clima de Corrientes, información actualizada" style={{ textDecoration: "none" }}><div className={styles["clima-botones-ciudades"]}>CORRIENTES</div></a>
                        <a href="/servicios/clima/parana" title="Ver clima actualizado de Paraná" aria-label="Acceder al clima de Paraná, información actualizada" style={{ textDecoration: "none" }}><div className={styles["clima-botones-ciudades"]}>PARANÁ</div></a>
                        <a href="/servicios/clima/concordia" title="Ver clima actualizado de Concordia" aria-label="Acceder al clima de Concordia, información actualizada" style={{ textDecoration: "none" }}><div className={styles["clima-botones-ciudades"]}>CONCORDIA</div></a>
                        <a href="/servicios/clima/gualeguaychu" title="Ver clima actualizado de Gualeguaychú" aria-label="Acceder al clima de Gualeguaychú, información actualizada" style={{ textDecoration: "none" }}><div className={styles["clima-botones-ciudades"]}>GUALEGUAYCHÚ</div></a>
                        <a href="/servicios/clima/cordoba" title="Ver clima actualizado de Córdoba" aria-label="Acceder al clima de Córdoba, información actualizada" style={{ textDecoration: "none" }}><div className={styles["clima-botones-ciudades"]}>CÓRDOBA</div></a>
                        <a href="/servicios/clima/ciudad-de-buenos-aires" title="Ver clima actualizado de Buenos Aires" aria-label="Acceder al clima de Buenos Aires, información actualizada" style={{ textDecoration: "none" }}><div className={styles["clima-botones-ciudades"]}>BUENOS AIRES</div></a>
                        <a href="/servicios/clima/la-plata" title="Ver clima actualizado de La Plata" aria-label="Acceder al clima de La Plata, información actualizada" style={{ textDecoration: "none" }}><div className={styles["clima-botones-ciudades"]}>LA PLATA</div></a>
                    </div>

                </div>
            </div>
            <Footer />
        </>
    );
};

export default Clima;
